/**
 * Admin-debug rows for stage-1 quality check / intake (player roster, gate, camera).
 * Data lives on Analysis.raw_gemini_response.intake after persistence.
 */

function formatPlayerRoster(playerDetections) {
  if (!Array.isArray(playerDetections) || !playerDetections.length) {
    return '—';
  }
  return playerDetections
    .map((row, i) => {
      const team = row?.team ?? 'unknown';
      const label = (row?.label || '').trim() || '(no label)';
      const desc = (row?.description || '').trim() || '(no description)';
      return `${i + 1}. [${team}] ${label}\n   ${desc}`;
    })
    .join('\n\n');
}

/**
 * @param {Record<string, unknown>|null|undefined} rawGeminiResponse
 * @returns {{ label: string, value: unknown }[]}
 */
export function buildQualityCheckDebugItems(rawGeminiResponse) {
  const raw =
    rawGeminiResponse && typeof rawGeminiResponse === 'object' ? rawGeminiResponse : {};
  const intake = raw.intake && typeof raw.intake === 'object' ? raw.intake : {};
  const payload =
    intake.payload && typeof intake.payload === 'object' ? intake.payload : {};
  const players = Array.isArray(payload.player_detections) ? payload.player_detections : [];

  const gateKnown =
    typeof payload.is_beach_volleyball === 'boolean' &&
    typeof payload.beach_volleyball_confidence === 'number';
  const passedGate = gateKnown
    ? Boolean(payload.is_beach_volleyball && payload.beach_volleyball_confidence >= 0.7)
    : null;

  return [
    { label: 'QC intake model', value: String(intake.model || '—') },
    { label: 'Beach volleyball', value: String(payload.is_beach_volleyball ?? '—') },
    { label: 'BV confidence', value: String(payload.beach_volleyball_confidence ?? '—') },
    {
      label: 'Quality gate (derived)',
      value: passedGate === null ? 'unknown' : String(passedGate),
    },
    { label: 'Block reason', value: payload.block_reason != null ? String(payload.block_reason) : '—' },
    {
      label: 'our_team side @ video start',
      value: String(payload.our_team_side_at_video_start || '—'),
    },
    { label: 'Camera view', value: String(payload.camera_view || '—') },
    { label: 'QC notes', value: payload.notes != null && String(payload.notes).trim() ? String(payload.notes) : '—' },
    { label: 'Player count', value: String(players.length) },
    { label: 'Players (QC roster)', value: formatPlayerRoster(players) },
    { label: 'player_detections (JSON)', value: players.length ? players : [] },
  ];
}
